export const formatCustomFieldsBeforeSubmit = (customFields) => {
    customFields.forEach((customField) => {
        if (Array.isArray(customField.value)) {
            customField.value = customField.value.map((value) => {
                if (
                    hasAllProperties(value, ['id', 'customFieldType'])
                    && ['item', 'contact', 'third', 'staff'].includes(value.customFieldType)
                ) {
                    return value.id;
                }

                return value;
            });
        }
    });

    return customFields;
};

const hasAllProperties = (obj, properties) => {
    return properties.every((property) => obj.hasOwnProperty(property) && !_.isNil(obj[property]));
};
